// import {
//   Drawer,
//   Box,
//   Typography,
//   Checkbox,
//   Button,
//   FormControlLabel,
//   TextField,
//   Divider,
//   IconButton,
//   MenuItem,
//   Select,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { useEffect, useMemo, useState } from "react";
// import api from "../../../services/api";
// import { BASE_URL } from "../../../services/configUrls";

// const AssignTrainerDomainsDrawer = ({ open, onClose, trainer }) => {
//   const [domains, setDomains] = useState([]);
//   const [search, setSearch] = useState("");
//   const [eventType, setEventType] = useState("fdp");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (trainer && eventType) fetchDomains();
//   }, [trainer, eventType]);

//   const fetchDomains = async () => {
//     setLoading(true);
//     try {
//       const res = await api.post(`${BASE_URL}/event/trainer/active/domains`, {
//         trainer_id: trainer.trainer_id,
//         event_type: eventType,
//       });
//       // Map response to is_active: 1/0
//       const data = res.data.data.map((d) => ({
//         ...d,
//         is_active: d.status === "Active" ? 1 : 0,
//       }));
//       setDomains(data);
//     } catch (err) {
//       console.error("Error fetching domains:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filteredDomains = useMemo(() => {
//     return domains.filter((d) =>
//       d.domain_name.toLowerCase().includes(search.toLowerCase())
//     );
//   }, [domains, search]);

//   const allSelected =
//     filteredDomains.length > 0 &&
//     filteredDomains.every((d) => d.is_active === 1);

//   const handleToggle = (domain_id) => {
//     setDomains((prev) =>
//       prev.map((d) =>
//         d.domain_id === domain_id
//           ? { ...d, is_active: d.is_active === 1 ? 0 : 1 }
//           : d
//       )
//     );
//   };

//   const handleSelectAll = (checked) => {
//     setDomains((prev) =>
//       prev.map((d) =>
//         filteredDomains.some((fd) => fd.domain_id === d.domain_id)
//           ? { ...d, is_active: checked ? 1 : 0 }
//           : d
//       )
//     );
//   };

//   const handleUpdate = async () => {
//     try {
//       const activeDomainIds = domains
//         .filter((d) => d.is_active === 1)
//         .map((d) => d.domain_id);

//       await api.post(`${BASE_URL}/event/trainer/activate/domains`, {
//         trainer_id: trainer.trainer_id,
//         event_type: eventType,
//         domain_ids: activeDomainIds,
//       });

//       // Refetch to refresh UI
//       await fetchDomains();
//     } catch (err) {
//       console.error("Error updating domains:", err);
//     }
//   };

//   return (
//     <Drawer anchor="right" open={open} onClose={onClose}>
//       <Box
//         sx={{
//           width: 420,
//           height: "100vh",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             p: 2,
//             bgcolor: "#EAF6FF",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Typography fontWeight={600}>
//             Manage Domains – {trainer?.fullname}
//           </Typography>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         {/* Event Type + Search */}
//         <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
//           <Select
//             value={eventType}
//             onChange={(e) => setEventType(e.target.value)}
//             fullWidth
//             size="small"
//           >
//             <MenuItem value="fdp">FDP</MenuItem>
//             <MenuItem value="edp">EDP</MenuItem>
//             <MenuItem value="techcamp">TechCamp</MenuItem>
//           </Select>

//           <TextField
//             fullWidth
//             size="small"
//             placeholder="Search domains..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={allSelected}
//                 onChange={(e) => handleSelectAll(e.target.checked)}
//               />
//             }
//             label="Select All"
//           />
//         </Box>

//         <Divider />

//         {/* Domains List */}
//         <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
//           {loading ? (
//             <Typography textAlign="center" sx={{ mt: 2 }}>
//               Loading...
//             </Typography>
//           ) : filteredDomains.length === 0 ? (
//             <Typography textAlign="center" sx={{ mt: 2 }}>
//               No domains found
//             </Typography>
//           ) : (
//             filteredDomains.map((domain) => (
//               <Box
//                 key={domain.domain_id}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   px: 1,
//                   py: 1,
//                   mb: 0.5,
//                   borderRadius: 1,
//                   cursor: "pointer",
//                   bgcolor: domain.is_active ? "#EAF6FF" : "transparent",
//                   "&:hover": { bgcolor: "#F5FAFF" },
//                 }}
//                 onClick={() => handleToggle(domain.domain_id)}
//               >
//                 <Checkbox checked={domain.is_active === 1} />
//                 <Typography>{domain.domain_name}</Typography>
//               </Box>
//             ))
//           )}
//         </Box>

//         <Divider />

//         {/* Footer */}
//         <Box sx={{ p: 2, display: "flex", gap: 2 }}>
//           <Button fullWidth variant="outlined" onClick={onClose}>
//             Cancel
//           </Button>
//           <Button fullWidth variant="contained" onClick={handleUpdate}>
//             Update
//           </Button>
//         </Box>
//       </Box>
//     </Drawer>
//   );
// };

// export default AssignTrainerDomainsDrawer;

import {
  Drawer,
  Box,
  Typography,
  Checkbox,
  Button,
  FormControlLabel,
  TextField,
  Divider,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";
import { BASE_URL } from "../../../services/configUrls";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";


const AssignTrainerDomainsDrawer = ({ open, onClose, trainer }) => {
  const [domains, setDomains] = useState([]);
  const [search, setSearch] = useState("");
  const [eventType, setEventType] = useState("fdp");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
  open: false,
  message: "",
  severity: "success", // success | error | warning | info
});

  const handleSnackbarClose = () => {
  setSnackbar((prev) => ({ ...prev, open: false }));
};


  // Reset state when a new trainer is opened
  useEffect(() => {
  if (trainer) {
    setEventType("fdp");
    setSearch("");
  }
}, [trainer]);

  // Fetch domains when eventType changes
  useEffect(() => {
  if (open && trainer && eventType) {
    fetchDomains(eventType);
  }
}, [open, trainer, eventType]);

  const fetchDomains = async (type) => {
    setLoading(true);
    try {
      const res = await api.post(`${BASE_URL}/event/trainer/active/domains`, {
        trainer_id: trainer.trainer_id,
        event_type: type,
      });

      const data = res.data.data.map((d) => ({
        ...d,
        is_active: d.status === "Active" ? 1 : 0,
      }));

      setDomains(data);
    } catch (err) {
      console.error("Error fetching domains:", err);
      setDomains([]);
    } finally {
      setLoading(false);
    }
  };

  // Filter domains safely
  const filteredDomains = useMemo(() => {
    return domains.filter((d) =>
      (d.domain_name || "").toLowerCase().includes(search.toLowerCase())
    );
  }, [domains, search]);

  const allSelected =
    filteredDomains.length > 0 &&
    filteredDomains.every((d) => d.is_active === 1);

  const handleToggle = (domain_id) => {
    setDomains((prev) =>
      prev.map((d) =>
        d.domain_id === domain_id
          ? { ...d, is_active: d.is_active === 1 ? 0 : 1 }
          : d
      )
    );
  };

  const handleSelectAll = (checked) => {
    setDomains((prev) =>
      prev.map((d) =>
        filteredDomains.some((fd) => fd.domain_id === d.domain_id)
          ? { ...d, is_active: checked ? 1 : 0 }
          : d
      )
    );
  };

  // const handleUpdate = async () => {
  //   try {
  //     const activeDomainIds = domains
  //       .filter((d) => d.is_active === 1)
  //       .map((d) => d.domain_id);

  //     await api.post(`${BASE_URL}/event/trainer/activate/domains`, {
  //       trainer_id: trainer.trainer_id,
  //       event_type: eventType,
  //       domain_ids: activeDomainIds,
  //     });

  //     // Refetch to refresh UI
  //     fetchDomains(eventType);
  //   } catch (err) {
  //     console.error("Error updating domains:", err);
  //   }
  // };
  const handleUpdate = async () => {
  try {
    const activeDomainIds = domains
      .filter((d) => d.is_active === 1)
      .map((d) => d.domain_id);

    const res = await api.post(
      `${BASE_URL}/event/trainer/activate/domains`,
      {
        trainer_id: trainer.trainer_id,
        event_type: eventType,
        domain_ids: activeDomainIds,
      }
    );

    // ✅ Success Snackbar
    setSnackbar({
      open: true,
      message: res.data?.message || "Domains updated successfully",
      severity: "success",
    });

    fetchDomains(eventType);
  } catch (err) {
    const errorMsg =
      err.response?.data?.detail ||
      err.response?.data?.message ||
      "Failed to update domains";

    // ❌ Error Snackbar
    setSnackbar({
      open: true,
      message: errorMsg,
      severity: "error",
    });
  }
};



  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box
        sx={{
          width: 420,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2,
            bgcolor: "#EAF6FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography fontWeight={600}>
            Manage Domains – {trainer?.fullname || "Trainer"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Event Type + Search */}
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Select
            value={eventType}
            onChange={(e) => setEventType(e.target.value)}
            fullWidth
            size="small"
          >
            <MenuItem value="fdp">FDP</MenuItem>
            <MenuItem value="edp">EDP</MenuItem>
            <MenuItem value="techcamp">TechCamp</MenuItem>
          </Select>

          <TextField
            fullWidth
            size="small"
            placeholder="Search domains..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={allSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
            }
            label="Select All"
          />
        </Box>

        <Divider />

        {/* Domains List */}
        <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
          {loading ? (
            <Typography textAlign="center" sx={{ mt: 2 }}>
              Loading...
            </Typography>
          ) : filteredDomains.length === 0 ? (
            <Typography textAlign="center" sx={{ mt: 2 }}>
              No domains found
            </Typography>
          ) : (
            filteredDomains.map((domain) => (
              <Box
                key={domain.domain_id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 1,
                  py: 1,
                  mb: 0.5,
                  borderRadius: 1,
                  cursor: "pointer",
                  bgcolor: domain.is_active ? "#EAF6FF" : "transparent",
                  "&:hover": { bgcolor: "#F5FAFF" },
                }}
                onClick={() => handleToggle(domain.domain_id)}
              >
                <Checkbox checked={domain.is_active === 1} />
                <Typography>{domain.domain_name || "N/A"}</Typography>
              </Box>
            ))
          )}
        </Box>

        <Divider />

        {/* Footer */}
        <Box sx={{ p: 2, display: "flex", gap: 2 }}>
          <Button fullWidth variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button fullWidth variant="contained" onClick={handleUpdate}>
            Update
          </Button>
        </Box>
      </Box>
      <Snackbar
  open={snackbar.open}
  autoHideDuration={3000}
  onClose={handleSnackbarClose}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
>
  <Alert
    onClose={handleSnackbarClose}
    severity={snackbar.severity}
    variant="filled"
    sx={{ width: "100%" }}
  >
    {snackbar.message}
  </Alert>
</Snackbar>

    </Drawer>
  );
};

export default AssignTrainerDomainsDrawer;
